import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { ToggleInput } from "@common/toggleInput";
import { Props } from "./types";
import styles from "./styles.scss";

function Header({ toggled, toggle }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.header}>
      <h3 className={styles.label}>
        {t("taskRetrieval.allocations.resource")}
      </h3>
      <h3 className={classNames(styles.label, styles.center)}>
        {t("taskRetrieval.allocations.allocatedHours")}
      </h3>
      <h3 className={classNames(styles.label, styles.center)}>
        {t("taskRetrieval.allocations.progress")}
      </h3>
      <div className={styles.removeAllocation}>
        <div className={styles.actions} onClick={toggle}>
          <p className={styles.label}>{t("workLoads.labels.groups")}</p>
          <ToggleInput isToggled={toggled} />
        </div>
      </div>
    </div>
  );
}

export { Header };
